import * as swcHelpers from '@swc/helpers';
import { DataLayer, calcPrice, priceVatCalc } from '@grandvisionhq/analytics';
import { isDefined } from '@grandvisionhq/utils';

const calcSumPrices = (...args)=>calcPrice(args.reduce((sum, n)=>sum + (n !== null && n !== void 0 ? n : 0)
    , 0))
;
const parsePrice = (price, vatRate)=>{
    var ref;
    if (!price) return {
        regularPrice: null,
        discountedPrice: null,
        discountAmount: null,
        vatAmount: null
    };
    const regularPrice = price.originalPrice;
    var ref1;
    const discountedPrice = (ref1 = (ref = price.discount) === null || ref === void 0 ? void 0 : ref.price) !== null && ref1 !== void 0 ? ref1 : null;
    const { vatAmount  } = discountedPrice !== null ? priceVatCalc(discountedPrice, vatRate) : priceVatCalc(regularPrice, vatRate);
    return {
        regularPrice,
        discountedPrice,
        discountAmount: discountedPrice ? regularPrice - discountedPrice : 0,
        vatAmount
    };
};
const getPrices = (variant, vat)=>{
    if (!variant) {
        console.warn('No variant data found.');
        return null;
    }
    if (typeof vat === 'undefined') {
        console.warn(`No VAT amount found for variant with SKU ${variant.sku}.`);
        return null;
    }
    const pricing = typeof variant.pricing.price.originalPrice !== 'undefined';
    if (!pricing) {
        console.warn(`Variant with SKU ${variant.sku} doesn't have any pricing.`);
        return null;
    }
    const productPricing = parsePrice(variant.pricing.price, vat);
    return {
        original: calcSumPrices(productPricing.regularPrice),
        discountedPrice: productPricing.discountedPrice !== null ? calcSumPrices(productPricing.discountedPrice) : calcSumPrices(productPricing.regularPrice),
        discountAmount: calcSumPrices(productPricing.discountAmount),
        vatAmount: calcSumPrices(productPricing.vatAmount)
    };
};
const getSharedAttributes = (product, purchaseType, activeVariant, lineItemType)=>{
    const { DataLayerTypes: { Stock , BrandType  } ,  } = DataLayer;
    const { sku  } = activeVariant;
    const prices = getPrices(activeVariant, product.includedVatAmount);
    const name = [
        ...new Set([
            activeVariant.brand.name,
            activeVariant.brand.model,
            activeVariant.brand.modelCode
        ].filter(Boolean)), 
    ].join(' ').trim();
    let dimension193 = '';
    if (isDefined(activeVariant.isExclusiveBrand)) {
        dimension193 = activeVariant.isExclusiveBrand ? BrandType.OwnBrand : BrandType.ExternalBrand;
    }
    return {
        name,
        id: sku || '',
        price: (prices === null || prices === void 0 ? void 0 : prices.discountedPrice) || '',
        dimension143: purchaseType,
        dimension144: lineItemType,
        dimension145: 'true',
        dimension190: `${activeVariant.erpId}`,
        dimension193,
        dimension194: product.isOnStock ? Stock.InStock : Stock.OutOfStock,
        metric140: (prices === null || prices === void 0 ? void 0 : prices.original) || '',
        metric141: (prices === null || prices === void 0 ? void 0 : prices.discountAmount) || '',
        metric142: (prices === null || prices === void 0 ? void 0 : prices.vatAmount) || ''
    };
};
const getSunglassesAttributes = (sharedAttributes, product, activeVariant)=>{
    var ref, ref2, ref3, ref4, ref5, ref6;
    return swcHelpers.objectSpread({}, sharedAttributes, {
        category: DataLayer.DataLayerTypes.Category.Sunglasses,
        brand: activeVariant.brand.name || '',
        variant: ((ref = activeVariant.frame.shape.en) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || '',
        dimension16: ((ref2 = activeVariant.gender.en) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || '',
        dimension140: product.masterVariant.sku || '',
        dimension146: ((ref3 = activeVariant.frame.material.en) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) || '',
        dimension147: ((ref4 = activeVariant.frame.color.en) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) || '',
        dimension191: ((ref5 = activeVariant.frame.type.en) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) || '',
        dimension192: ((ref6 = activeVariant.faceShape) === null || ref6 === void 0 ? void 0 : ref6.en.toLowerCase()) || ''
    });
};
const getContactLensesAttributes = (sharedAttributes, product, activeVariant)=>{
    var ref;
    return swcHelpers.objectSpread({}, sharedAttributes, {
        name: activeVariant.name || '',
        brand: activeVariant.brand.name,
        category: DataLayer.DataLayerTypes.Category.ContactLenses,
        variant: ((ref = activeVariant.lensType) === null || ref === void 0 ? void 0 : ref.en) || '',
        dimension140: product.masterVariant.sku || '',
        dimension148: activeVariant.replacementFrequency || '',
        dimension146: activeVariant.material
    });
};
const getPrescriptionGlassesAttributes = (sharedAttributes, product, activeVariant)=>{
    var ref, ref7, ref8, ref9, ref10, ref11;
    const frameColor = ((ref = activeVariant.frame.color.en) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || '';
    const frameMaterial = ((ref7 = activeVariant.frame.material.en) === null || ref7 === void 0 ? void 0 : ref7.toLowerCase()) || '';
    return swcHelpers.objectSpread({}, sharedAttributes, {
        brand: activeVariant.brand.name,
        variant: ((ref8 = activeVariant.frame.shape.en) === null || ref8 === void 0 ? void 0 : ref8.toLowerCase()) || '',
        dimension140: product.masterVariant.sku,
        dimension16: ((ref9 = activeVariant.gender.en) === null || ref9 === void 0 ? void 0 : ref9.toLocaleLowerCase()) || '',
        dimension191: ((ref10 = activeVariant.frame.type.en) === null || ref10 === void 0 ? void 0 : ref10.toLowerCase()) || '',
        dimension192: ((ref11 = activeVariant.faceShape) === null || ref11 === void 0 ? void 0 : ref11.en.toLowerCase()) || '',
        category: DataLayer.DataLayerTypes.Category.Optical
    }, frameMaterial ? {
        dimension146: frameMaterial
    } : null, frameColor ? {
        dimension147: frameColor
    } : null);
};
const getSolutionsAttributes = (sharedAttributes, product, activeVariant)=>swcHelpers.objectSpread({}, sharedAttributes, {
        name: activeVariant.name,
        category: DataLayer.DataLayerTypes.Category.Solutions,
        brand: activeVariant.brand.name,
        variant: activeVariant.packageOption || '',
        dimension140: String(product.masterVariant.sku),
        dimension146: activeVariant.solutionType
    })
;
const getReadyReadersAttributes = (sharedAttributes, product, activeVariant)=>{
    var ref, ref12, ref13, ref14, ref15, ref16;
    return swcHelpers.objectSpread({}, sharedAttributes, {
        category: DataLayer.DataLayerTypes.Category.ReadyReaders,
        brand: activeVariant.brand.name,
        variant: ((ref = activeVariant.frame.shape.en) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || '',
        dimension16: ((ref12 = activeVariant.gender.en) === null || ref12 === void 0 ? void 0 : ref12.toLocaleLowerCase()) || '',
        dimension140: product.masterVariant.sku,
        dimension146: ((ref13 = activeVariant.frame.material.en) === null || ref13 === void 0 ? void 0 : ref13.toLowerCase()) || '',
        dimension147: ((ref14 = activeVariant.frame.color.en) === null || ref14 === void 0 ? void 0 : ref14.toLowerCase()) || '',
        dimension191: ((ref15 = activeVariant.frame.type.en) === null || ref15 === void 0 ? void 0 : ref15.toLowerCase()) || '',
        dimension192: ((ref16 = activeVariant.faceShape) === null || ref16 === void 0 ? void 0 : ref16.en.toLowerCase()) || ''
    });
};
const getAccessoriesAttributes = (sharedAttributes, product, activeVariant)=>{
    var ref, ref17, ref18, ref19;
    return swcHelpers.objectSpread({}, sharedAttributes, {
        category: DataLayer.DataLayerTypes.Category.Accessories,
        brand: activeVariant.brand.name,
        variant: ((ref = activeVariant.accessoryType.en) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || '',
        dimension16: ((ref17 = activeVariant.gender.en) === null || ref17 === void 0 ? void 0 : ref17.toLocaleLowerCase()) || '',
        dimension146: ((ref18 = activeVariant.material) === null || ref18 === void 0 ? void 0 : ref18.toLowerCase()) || '',
        dimension147: ((ref19 = activeVariant.accessoryColor.en) === null || ref19 === void 0 ? void 0 : ref19.toLowerCase()) || '',
        dimension140: product.masterVariant.sku || ''
    });
};
const mapProductListingToDataLayerProductObject = (purchaseType, product, activeSku)=>{
    const activeVariant = [
        product.masterVariant,
        ...product.variants
    ].find((variant)=>variant.sku === activeSku
    ) || product.masterVariant;
    const sharedAttributes = getSharedAttributes(product, purchaseType, activeVariant, DataLayer.DataLayerTypes.LineItemType.Single);
    if (product.productType === 'Sunglasses') {
        return getSunglassesAttributes(sharedAttributes, product, activeVariant);
    }
    if (product.productType === 'Contact-lenses') {
        return getContactLensesAttributes(sharedAttributes, product, activeVariant);
    }
    if (product.productType === 'Frames') {
        return getPrescriptionGlassesAttributes(sharedAttributes, product, activeVariant);
    }
    if (product.productType === 'Ready-readers') {
        return getReadyReadersAttributes(sharedAttributes, product, activeVariant);
    }
    if (product.productType === 'Accessories') {
        return getAccessoriesAttributes(sharedAttributes, product, activeVariant);
    }
    if (product.productType === 'Solutions') {
        return getSolutionsAttributes(sharedAttributes, product, activeVariant);
    }
};

export { mapProductListingToDataLayerProductObject };
//# sourceMappingURL=ProductListingMapper.js.map
